export const ScheduledReportFrequency = {
    None: 0,
    Daily: 1,
    Weekly: 2,
    Monthly: 3,
} as const;

export type ScheduledReportFrequency = (typeof ScheduledReportFrequency)[keyof typeof ScheduledReportFrequency];

// ----- AlertConfiguration (per location) -----
export interface AlertConfiguration {
    locationId: string;
    triggerEmailAddresses?: string | null;
    triggerPhoneNumbers?: string | null;
    created: string;
    createdBy: string;
    updated?: string | null;
    updatedBy?: string | null;
}

export interface UpsertAlertConfiguration {
    triggerEmailAddresses?: string | null;
    triggerPhoneNumbers?: string | null;
}

// ----- ReportConfiguration -----
export interface ReportConfiguration {
    id: string;
    brandId?: string | null;
    locationId?: string | null;
    reportEmailAddresses: string;
    reportFrequency: ScheduledReportFrequency;
    lastRunDateTime?: string | null; // server-managed
    nextRunDateTime?: string | null; // server-managed
    created: string;
    createdBy: string;
    updated?: string | null;
    updatedBy?: string | null;
}

export interface CreateReportConfiguration {
    brandId?: string | null;
    locationId?: string | null;
    reportEmailAddresses: string;
    reportFrequency: ScheduledReportFrequency;
}

export type UpdateReportConfiguration = CreateReportConfiguration;
